import InvoiceService from "@/store/services/invoice.service.js"
import InvoiceRecurrentService from "@/store/services/invoice.recurrent.service.js"
import InvoicePaymentsService from "@/store/services/invoice.payments.service.js"
import TaxRateService from "@/store/services/taxrate.service.js"
import QuotationService from "@/store/services/quotation.service.js"
import ProductGroupService from "@/store/services/productgroup.service.js";
import DocumentService from "@/store/services/document.service";

export default {
  namespaced: true,
  state: {
    invoice: null,
    isQuotation: false,
    recurrentInvoice: null,
    recurrentInvoiceBackup: null,
    invoicePayments: [],
    invoicePDF: null,
    invoiceToCopy: null,
    statusOptions: [],
    companyTaxRates: null,
    creditableStatuses: ['sent', 'sending', 'paid', 'overdue'],
    invoiceCreateRecipient: null,
    invoiceCreateProject: null,
    refreshFlag: false,
    retentionRates: [
      { name: '15', taxrate: 15 },
      { name: '7', taxrate: 7 },
      { name: '2', taxrate: 2 },
      { name: '1', taxrate: 1 },
      { name: '0', taxrate: 0 },
    ],
    sendDetails: null,
    productGroups: null,
    exchangeRates: null,
    tempInvoiceList: [],
    tempInvoiceListNext: null,
    correctionFiles: [],
    quotationFiles: [],
    quotationToChange: null,
    invoiceCustomers: [],
    refreshCustomerList: false,
    isVerifactuInvoice: false
  },
  getters: {
    getInvoice: state => state.invoice,

    getRecurrentInvoice: state => state.recurrentInvoice,
    getRecurrentInvoiceBackup: state => state.recurrentInvoiceBackup,

    getInvoicePDF: state => state.invoicePDF,
    getInvoicePayments: state => state.invoicePayments,
    getInvoiceToCopy: state => state.invoiceToCopy,

    getSendDetails: state => state.sendDetails,

    getCompanyTaxRates: state => state.companyTaxRates,
    getCreditableStatuses: state => state.creditableStatuses,

    getInvoiceCreateRecipient: state => state.invoiceCreateRecipient,
    getInvoiceCreateProject: state => state.invoiceCreateProject,

    getRetentionRates: state => state.retentionRates,
    getStatusOptions: state => state.statusOptions,

    getProductGroups: state => state.productGroups,

    getExchangeRates: state => state.exchangeRates,

    getTempInvoiceList: state => state.tempInvoiceList,
    getTempInvoiceListNext: state => state.tempInvoiceListNext,

    getCorrectionFiles: state => state.correctionFiles,

    getIsQuotation: state => state.isQuotation,
    getQuotationFiles: state => state.quotationFiles,
    getQuotationToChange: state => state.quotationToChange,

    getInvoiceCustomers: state => state.invoiceCustomers,
    getInvoiceCustomerById: state => id => state.invoiceCustomers.find(c => c.id === id),
    getInvoiceCustomerByProjectId: state => projectId =>
      state.invoiceCustomers.find(customer =>
        customer.projects?.some(project => project.id === projectId)
      ),

    getRefreshCustomerList: state => state.refreshCustomerList,

    getScheduledForToday: state => {
      return state.recurrentInvoice && state.recurrentInvoice.start_date == Date.today().format("Y-m-d")
    },
    getIsVerifactuInvoice: state => state.isVerifactuInvoice
  },
  mutations: {
    SET_INVOICE (state, invoice) {
      state.invoice = invoice
    },
    SET_INVOICE_STATUS (state, status) {
      state.invoice.status = status
    },
    SET_IS_QUOTATION (state, quotation) {
      state.isQuotation = quotation
    },
    SET_RECURRENT_INVOICE (state, recurrent) {
      if (recurrent && recurrent.days && recurrent.days != '') {
        if (!Array.isArray(recurrent.days)) {
          recurrent.days = recurrent.days.split(',')
        }
      }
      
      state.recurrentInvoice = recurrent
    },
    SET_RECURRENT_INVOICE_BACKUP (state, recurrent) {
      state.recurrentInvoiceBackup = recurrent
    },
    
    SET_INVOICE_PDF (state, invoicePDF) {
      state.invoicePDF = invoicePDF
    },
    SET_INVOICE_PAYMENTS (state, invoicePayments) {
      state.invoicePayments = invoicePayments
    },
    SET_INVOICE_PAYMENT (state, payment) {
      state.invoice.invoice_payment = payment
    },
    SET_INVOICE_PAID_UPFRONT (state, paid) {
      state.invoice.paid_up_front = paid
    },
    SET_INVOICE_TOTAL_AMOUNT (state, amount) {
      state.invoice.total_amount = amount;
    },
    SET_STATUS_OPTIONS(state, options) {
      state.statusOptions = options;
    },
    SET_INVOICE_TO_COPY (state, invoiceToCopy) { // not used yet
      state.invoiceToCopy = invoiceToCopy;
    },
    SET_INVOICE_SEND_DETAILS (state, sendDetails) {
      state.sendDetails = sendDetails
    },
    SET_INVOICE_CREATE_RECIPIENT (state, recipient) {
      state.invoiceCreateRecipient = recipient
    },
    SET_INVOICE_CREATE_PROJECT (state, project) {
      state.invoiceCreateProject = project
    },
    SET_COMPANY_TAX_RATES (state, taxRates) {
      state.companyTaxRates = taxRates
    },
    REFRESH_INVOICE_LIST (state) {
      state.refreshFlag = !state.refreshFlag
    },
    REFRESH_INVOICE_RECURRENT_LIST (state) {
      state.refreshFlag = !state.refreshFlag
    },
    ADD_INVOICE_PAYMENT (state, payment) {
      state.invoicePayments.push(payment)
    },
    DELETE_INVOICE_PAYMENT (state, paymentIndex) {
      state.invoicePayments.splice(paymentIndex, 1)
    },
    SET_PRODUCT_GROUPS (state, groups) {
      state.productGroups = groups
    },
    SET_EXCHANGE_RATES (state, rates) {
      state.exchangeRates = rates
    },
    SET_TEMP_INVOICE_LIST (state, invoiceList) {
      state.tempInvoiceList = invoiceList
    },
    SET_TEMP_INVOICE_LIST_NEXT (state, next) {
      state.tempInvoiceListNext = next
    },
    SET_CORRECTION_FILES (state, files) {
      state.correctionFiles = files
    },
    DELETE_CORRECTION_FILE (state, documentIndex) {
      state.correctionFiles.splice(documentIndex, 1)
    },
    SET_QUOTATION_FILES (state, files) {
      state.quotationFiles = files
    },
    DELETE_QUOTATION_FILE (state, documentIndex) {
      state.quotationFiles.splice(documentIndex, 1)
    },
    SET_QUOTATION_TO_CHANGE (state, quotationToChange) {
      state.quotationToChange = quotationToChange;
    },
    ADD_QUOTATION_FILE (state, file) {
      state.quotationFiles.push(file)
    },
    SET_INVOICE_CUSTOMERS (state, customers) {
      state.invoiceCustomers = customers
    },
    SET_INVOICE_CUSTOMER (state, customer) {
      state.invoiceCustomers.push(customer)
    },
    SET_REFRESH_CUSTOMER_LIST (state, refresh_flag) {
      state.refreshCustomerList = refresh_flag
    },
    SET_IS_VERIFACTU_INVOICE (state, isVerifactuInvoice) {
      state.isVerifactuInvoice = isVerifactuInvoice
    }
  },
  actions: {
    setInvoiceToCopy ({ commit }, invoice) {
      commit('SET_INVOICE_TO_COPY', invoice)
    },
    setQuotationToChange ({ commit }, quotation) {
      commit('SET_QUOTATION_TO_CHANGE', quotation)
    },
    copyToCustomer ({ commit, getters, rootGetters }, selectedCustomer) {
      if (!rootGetters['main/getCurrentCompany'].is_premium) {
        commit('togglePremiumModal', 'web_invoices_copy', { root: true })
      } else {
        if (selectedCustomer.customer_id) {
          // TODO backend: project_id?
          const options = { recipient_customer: selectedCustomer.customer_id }
          if (selectedCustomer.project_id) {
            options.project = selectedCustomer.project_id
          }
          return InvoiceService.copyInvoice(getters.getInvoiceToCopy.id, options).then((response) => {
            commit('SET_INVOICE_TO_COPY', null)
            return response
          })
        }
      }
    },
    recurrentToDraft ({ commit, getters }) {
      commit('SET_INVOICE_STATUS', 'd')
      return InvoiceService.update(getters.getInvoice.id, getters.getInvoice).then((response) => {
        console.log('recurrentToDraft response', response)
      })
    },
    createInvoice (_, invoice) {
      let invoiceResponse
      return InvoiceService.create(invoice).then((response) => {
        invoiceResponse = response.data
        if (invoice.paid_up_front) {
          invoice.invoice_payment.invoice = invoiceResponse.id
          return InvoicePaymentsService.create(invoice.invoice_payment)
        }
        return invoiceResponse
      }).catch((response) => {
        if (invoiceResponse) {
          return InvoiceService.destroy(invoiceResponse.id)
        }
        throw response
      })
    },
    loadInvoice ({ dispatch }, invoiceId) {
      dispatch('resetInvoiceData')
      return Promise.all([
        dispatch('retrieveInvoice', invoiceId),
        dispatch('retrievePayments', invoiceId)
      ])
    },
    loadInvoiceRecurrent ({ dispatch }, invoiceId) {
      dispatch('resetInvoiceData')
      return Promise.all([
        dispatch('retrieveRecurrentInvoice', invoiceId),
      ])
    },
    retrieveInvoice ({ commit }, invoiceId) {
      return InvoiceService.retrieve(invoiceId, { extended: 'True' }).then((response) => {
        commit('SET_INVOICE', response.data)
      })
    },
    retrieveRecurrentInvoice ({ commit }, invoiceId) {
      return InvoiceRecurrentService.retrieve(invoiceId, { extended: 'True' }).then((response) => {
        commit('SET_INVOICE', response.data.invoice)
        commit('SET_RECURRENT_INVOICE', response.data)
      })
    },
    deleteInvoice ({ dispatch }, invoiceId) {
      return InvoiceService.destroy(invoiceId, { extended: 'True' }).then(() => {
        // dispatch('resetInvoice')
        // dispatch('resetInvoiceData')
      })
    },
    resetInvoice ({ commit }) {
      commit('SET_INVOICE', null)
    },
    resetInvoiceData ({ commit }) {
      commit('SET_INVOICE_PDF', null)
      commit('SET_RECURRENT_INVOICE', null)
      commit('SET_INVOICE_SEND_DETAILS', null)
      commit('SET_INVOICE_PAYMENTS', [])
      commit('SET_CORRECTION_FILES', [])
      commit('SET_QUOTATION_FILES', [])
    },
    // currently only for corrections
    loadCorrectionFiles ({ commit }, correctionId) {
      return DocumentService.getContentType({ type: 'Correction' }).then((response) => {
        return DocumentService.list({ content_type: response.data, object_id: correctionId }).then((response) => {
          commit('SET_CORRECTION_FILES', response.data.results)
        })
      })
    },
    retrievePayments ({ commit }, invoiceId) {
      return InvoicePaymentsService.list({ invoice: invoiceId }).then((response) => {
        commit('SET_INVOICE_PAYMENTS', response.data)
      })
    },
    loadExchangeRates ({ commit }) {
      return InvoiceService.getExchangeRates().then((response) => {
        commit('SET_EXCHANGE_RATES', response.data)
      })
    },
    addPayment ({ commit }, newPayment) {
      return InvoicePaymentsService.create(newPayment).then((response) => {
        commit('ADD_INVOICE_PAYMENT', response.data)
      })
    },
    deletePayment ({ commit, getters }, paymentId) {
      return InvoicePaymentsService.destroy(paymentId).then(() => {
        const payment_index = getters.getInvoicePayments.findIndex(payment => payment.id === paymentId)
        if (payment_index !== -1) {
          commit('DELETE_INVOICE_PAYMENT', payment_index)
        }
      })
    },
    // only for quotations
    removeAttachedDocument ({ commit, getters }, data) {
      let file_index
      if (data.type == 'Quotation') {
        file_index = getters.getQuotationFiles.findIndex(file => file.id === data.fileId)
        if (file_index !== -1) {
          commit('DELETE_QUOTATION_FILE', file_index)
        }
      }
    },
    // only for corrections
    deleteDocument ({ commit, getters }, data) {
      DocumentService.delete(data.fileId).then(() => {
        let file_index
        if (data.objectType == 'Correction') {
          file_index = getters.getCorrectionFiles.findIndex(file => file.id === data.fileId)
        }
        if (file_index !== -1) {
          commit('DELETE_CORRECTION_FILE', file_index)
        }
      })
    },
    addAttachedDocument ({ commit, getters }, data) {
      let existing_file
      if (data.type == 'Correction') {
        existing_file = getters.getCorrectionFiles.find(file => file.id === data.file.id)
        if (!existing_file) {
          commit('ADD_CORRECTION_FILE', data.file)
        }
      }
      if (data.type == 'Quotation') {
        existing_file = getters.getQuotationFiles.find(file => file.id === data.file.id)
        if (!existing_file) {
          commit('ADD_QUOTATION_FILE', data.file)
        }
      }
    },
    deleteQuotation (_, quotationId) {
      return QuotationService.destroy(quotationId, { extended: 'True' })
    },
    getNextInvoiceNumber (_, date) {
      return InvoiceService.getNextInvoiceNumber(date).then((response) => {
        return response.data
      })
    },
    getNextQuotationNumber (_, date) {
      return QuotationService.getNextQuotationNumber(date).then((response) => {
        return response.data
      })
    },
    loadQuotation ({ dispatch }, quotationId) {
      dispatch('resetInvoiceData')
      return Promise.all([
        dispatch('retrieveQuotation', quotationId),
      ])
    },
    retrieveQuotation ({ commit, dispatch }, quotationId) {
      return QuotationService.retrieve(quotationId, { extended: 'True' }).then((response) => {
        commit('SET_INVOICE', response.data)
        return dispatch('loadQuotationFiles')
      })
    },
    loadQuotationFiles ({ commit, getters, rootGetters }) {
      let invoice_documents = getters.getInvoice.documents
      if (invoice_documents && invoice_documents.length > 0) {
        return DocumentService.list({ 
          'company_profile': rootGetters['main/getCurrentCompany'].id,
          'id': invoice_documents.toString()
        }).then((response) => {
          commit('SET_QUOTATION_FILES', response.data.results)
        })
      }
    },
    loadCompanyTaxRates ({ commit, rootGetters }) {
      let taxRateFilters = {
        'country': rootGetters['main/getCurrentCompany'].country, 
      }

      let administrative_area = rootGetters['main/getCurrentCompany'].administrative_area;
      if (administrative_area) {
        taxRateFilters['administrative_area'] = administrative_area;
      }

      return TaxRateService.list(taxRateFilters).then((response) => {
        // let data = $filter('orderBy')(response.data, "-value");
        let data = response.data
        for (let i = 0;i < data.length; i++) {
          data[i].name = data[i].taxrate+"%";
          data[i].order = data[i].taxrate;
        }
        commit('SET_COMPANY_TAX_RATES', response.data)
      })
    },
    loadStatusOptions ({ commit }) {
      return InvoiceService.getStatusOptions().then((response) => {
        commit('SET_STATUS_OPTIONS', response.data)
      })
    },
    loadProductGroups ({ commit, rootGetters }) {
      return ProductGroupService.list({ 'company_profile': rootGetters['main/getCurrentCompany'].id }).then((response) => {
        commit('SET_PRODUCT_GROUPS', response.data)
      })
    },

    loadInvoiceCustomers ({ commit, rootGetters }) {
      return InvoiceService.customerList({ sender_company: rootGetters['main/getCurrentCompany'].id }).then((response) => {
        commit('SET_INVOICE_CUSTOMERS', response.data)
      })
    },

    loadInvoicesGlobalData ({ dispatch }) {
      return Promise.all([
        // dispatch('loadInvoiceCustomers'),
        dispatch('loadCompanyTaxRates'),
        dispatch('loadStatusOptions')
      ])
    }
  }
};
